<template>
  <v-form v-model="valid">
    <slot></slot>
    <v-select
      name="memberType"
      label="Member Type"
      item-text="name"
      item-value="value"
      :value="value.type"
      :items="memberTypes"
      :disabled="!isNew"
      @input="onChangeType"
    />
    <v-select
      v-show="subTypes.length > 0"
      name="subType"
      label="Sub Type"
      item-text="name"
      item-value="value"
      :items="subTypes"
      :item-disabled="o => !o.isActive"
      :value="value.subType"
      :disabled="!isNew"
      @input="onInput('subType', $event)"
    />
    <v-select
      name="licenseStatus"
      label="License Status"
      :value="value.licenseStatus"
      @input="onInput('licenseStatus', $event)"
      :items="licenseStatusOptions"
    />
    <v-checkbox
      v-show="siteVisitRequired"
      name="siteVisitComplete"
      label="Site visit complete"
      :input-value="value.siteVisitComplete"
      @change="onInput('siteVisitComplete', $event)"
    />
    <date-input
      v-show="siteVisitRequired"
      name="siteVisitCompletedAt"
      label="Site visit date"
      :value="value.siteVisitCompletedAt"
      @input="onInput('siteVisitCompletedAt', $event)"
      v-if="value.siteVisitComplete"
      clearable
    />
    <v-checkbox
      v-show="trainingRequired"
      name="trainingComplete"
      label="Face-to-face training complete"
      :input-value="value.trainingComplete"
      @change="onInput('trainingComplete', $event)"
    />
    <date-input
      v-show="trainingRequired"
      name="trainingCompletedAt"
      label="Training date"
      :value="value.trainingCompletedAt"
      @input="onInput('trainingCompletedAt', $event)"
      v-if="value.trainingComplete"
      clearable
    />
    <date-input
      name="startDate"
      label="From date"
      :value="value.from"
      @input="onInput('from', $event)"
      clearable
    />
    <date-input
      name="endDate"
      label="To date"
      :value="value.to"
      @input="onInput('to', $event)"
      clearable
    />
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { LicenseStatus } from '@mymsa/common'
import DateInput from '../inputs/DateInput.vue'

export default {
  name: 'ActivityForm',

  components: {
    DateInput
  },

  props: {
    value: {
      type: Object,
      default: () => ({
        _id: null,
        type: null,
        subType: null,
        from: null,
        to: null,
        licenseStatus: null,
        siteVisitComplete: false,
        siteVisitCompletedAt: null,
        trainingComplete: false,
        trainingCompletedAt: null
      })
    }
  },

  data: () => ({
    valid: false,
    memberTypes: [],
    licenseStatusOptions: [
      { text: 'Current', value: LicenseStatus.CURRENT },
      { text: 'Inactive', value: LicenseStatus.INACTIVE },
      { text: 'Alliance', value: LicenseStatus.ALLIANCE },
      { text: 'Pending', value: LicenseStatus.PENDING },
      { text: 'Terminated', value: LicenseStatus.TERMINATED }
    ]
  }),

  computed: {
    isNew () {
      return !this.value._id
    },
    memberType () {
      if (!this.value?.type) return null
      return this.memberTypes.find(o => o.value === this.value.type)
    },
    subTypes () {
      return this.memberType?.subTypes ?? []
    },
    siteVisitRequired () {
      return !!this.memberType?.siteVisitRequired
    },
    trainingRequired () {
      return !!this.memberType?.trainingRequired
    }
  },

  apollo: {
    memberTypes: {
      query: gql`query {
        memberTypes: memberTypeMany {
          _id
          name
          value
          siteVisitRequired
          trainingRequired
          subTypes {
            _id
            name
            value
            isActive
          }
        }
      }`,
      error (e) { this.$emit('error', e) }
    }
  },

  methods: {
    onInput (key, value) {
      const o = {
        ...this.value,
        [key]: value
      }
      this.$emit('input', o)
    },

    onDateRangeChange (event) {
      const [from, to] = event
      const o = {
        ...this.value,
        from: from || null,
        to: to || null
      }
      this.$emit('input', o)
    },

    onChangeType (e) {
      this.onInput('type', e)
      this.$nextTick(() => {
        this.onInput('subType', null)
      })
    }
  }
}
</script>
